function paramsOf(p) {
    const q = new URLSearchParams();
    if (p.from !== undefined)
        q.set('from', p.from);
    if (p.to !== undefined)
        q.set('to', p.to);
    if (p.markets !== undefined && p.markets.length > 0)
        q.set('markets', p.markets.join(','));
    if (p.origins !== undefined && p.origins.length > 0)
        q.set('origin', p.origins.join(','));
    if (p.statuses !== undefined && p.statuses.length > 0)
        q.set('status', p.statuses.join(','));
    if (p.aging !== undefined && p.aging.length > 0)
        q.set('aging', p.aging.join(','));
    if (p.blocked !== undefined && p.blocked !== 'any')
        q.set('blocked', p.blocked);
    if (p.sort !== undefined)
        q.set('sort', p.sort);
    if (p.limit !== undefined)
        q.set('limit', String(p.limit));
    if (p.offset !== undefined)
        q.set('offset', String(p.offset));
    return q;
}
const withQuery = (path, q) => (q.size === 0 ? path : `${path}?${q.toString()}`);
export class RiderDebtsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Market-level KPIs, age buckets and chart series (`analytics:view`); no rider, no ride. */
    summary(params = {}) {
        const q = paramsOf(params);
        return this.client.request({ method: 'GET', path: withQuery('/v1/analytics/rider-debts/summary', q), auth: true });
    }
    /** The riders in debt (`analytics:view` + `analytics:view_personal`); access-logged. */
    riders(params = {}) {
        return this.client.request({ method: 'GET', path: withQuery('/v1/analytics/rider-debts/riders', paramsOf(params)), auth: true });
    }
    /** One rider's debts and payments in a market (the personal words); access-logged. 404 `RIDER_DEBT_RIDER_NOT_FOUND` for a rider the market does not have. */
    history(riderId, market) {
        const q = new URLSearchParams();
        if (market !== undefined)
            q.set('market', market);
        return this.client.request({ method: 'GET', path: withQuery(`/v1/analytics/rider-debts/riders/${encodeURIComponent(riderId)}`, q), auth: true });
    }
    /** From a debt reference to the rider who owed it (the personal words); access-logged. 404 `RIDER_DEBT_DEBT_NOT_FOUND` for an unknown debt or one whose rider was erased. */
    debtOwner(debtRef, market) {
        const q = new URLSearchParams();
        if (market !== undefined)
            q.set('market', market);
        return this.client.request({ method: 'GET', path: withQuery(`/v1/analytics/rider-debts/debts/${encodeURIComponent(debtRef)}`, q), auth: true });
    }
    /** The CSV: `days` (the period's created / recovered per day, no person) or `riders` (the list, which also needs the personal word). Needs `analytics:export`. Always audited. */
    exportCsv(kind, params = {}, options = {}) {
        const q = paramsOf(params);
        q.set('kind', kind);
        if (options.delimiter === ';')
            q.set('delimiter', ';');
        return this.client.request({ method: 'GET', path: withQuery('/v1/analytics/rider-debts/export', q), auth: true, expect: 'text' });
    }
    /** The riders blocked for cash now in a market, with the releases proposed and decided (`rider_cash:view` + `analytics:view_personal`); access-logged. */
    cashBlocks(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/rider-cash-blocks?market=${encodeURIComponent(market)}`, auth: true });
    }
}
//# sourceMappingURL=rider-debts.js.map